/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-21 12:10:33
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 20:14:47
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/ReviewCard/Title/index.tsx
 */
import { modal } from '@/src/utils/Modal';
import React, { useContext } from 'react';
import { Button, Rate } from 'src/components/Antd';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Dots from 'src/constrains/DotsMenuDrop';
import { useI18n } from 'src/hooks/useRouterChange';
import { EnumReviewType } from 'src/pages/ProductReview/common';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import { ReplyContext } from '../index';
import css from './css.module.less';

const Title = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const canEdit = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsReview,
        operation: EnumOperation.add_edit_review,
      }),
    ],
  });

  const canPublish = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsReview,
        operation: EnumOperation.publish_unpublish_archive,
      }),
    ],
  });

  const canReply = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsReview,
        operation: EnumOperation.reply_review,
      }),
    ],
  });

  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsReview,
        operation: EnumOperation.delete_review,
      }),
    ],
  });

  const {
    title: name = getI18n('general.name'),
    rating = 0,
    hasReply,
    status,
    isFake,
    func,
    reviewUuid,
  } = props;
  const {
    onPublishAll,
    onUnPublishAll,
    onStatusChange,
    onReviewDelete,
    onEdit,
  } = func;

  const handleOnPublishAll = () => {
    if (onPublishAll) {
      onPublishAll({ uuid: reviewUuid });
    }
  };

  const handleOnUnPublishAll = () => {
    if (onPublishAll) {
      onUnPublishAll({ uuid: reviewUuid });
    }
  };

  const handleOnStatusChange = (status) => {
    if (onStatusChange) {
      onStatusChange({ uuid: reviewUuid, status });
    }
  };

  const handleOnReviewDelete = () => {
    if (onReviewDelete) {
      onReviewDelete({ uuid: reviewUuid });
    }
  };

  const _publishAll = {
    onClick: handleOnPublishAll,
    key: 'publishAll',
    body: getI18n(
      'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_publishAll_body',
    ),
  };

  const _unPublishAll = {
    onClick: handleOnUnPublishAll,
    key: 'unpublishAll',
    body: getI18n(
      'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_unpublishAll_body',
    ),
  };

  const _archive = {
    onClick: handleOnStatusChange.bind(this, EnumReviewType.Archive),
    key: 'archive',
    body: getI18n(
      'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_archive',
    ),
  };

  const _spam = {
    onClick: handleOnStatusChange.bind(this, EnumReviewType.Spam),
    key: 'spam',
    body: getI18n(
      'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_spam_body',
    ),
  };

  const _spamToPending = {
    onClick: handleOnStatusChange.bind(this, EnumReviewType.Pending),
    key: 'spamToPending',
    body: getI18n(
      'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_spamtopending_body',
    ),
  };

  const _arToPending = {
    onClick: handleOnStatusChange.bind(this, EnumReviewType.Pending),
    key: 'arToPending',
    body: getI18n(
      'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_arToPending_body',
    ),
  };

  const _edit = {
    onClick: onEdit,
    key: 'edit',
    body: getI18n(
      'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_edit_body',
    ),
  };

  const _deleteReview = {
    isDangerous: true,
    key: 'deleteReview',
    body: getI18n(
      'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_deleteReview_body',
    ),
    // displayWarningModal: true,
    onClick: () => {
      modal.error({
        title: getI18n(
          'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_deleteReview_body',
        ),
        content: getI18n(
          'reviews.productreview.productReviewDetail_ReviewCard_content_title_page_deletereview_error',
        ),
        onOkText: getI18n('general.delete'),
        onOk: () => {
          // console.log(onCancel);
          handleOnReviewDelete();
        },
        onCancel: () => {
          return;
        },
      });
    },
    // modalOnOk: handleOnReviewDelete,
    // modalOnCancel: () => {
    //   console.log('别删我');
    // },
    // modalTitle: 'Delete review',
    // modalContent: 'Delete review',
  };

  const __edit = canEdit ? [_edit] : [];

  const __publishAll = canPublish ? [_publishAll] : [];

  const __unPublishAll = canPublish ? [_unPublishAll] : [];

  const __archive = canPublish ? [_archive] : [];

  const __deleteReview = canDelete ? [_deleteReview] : [];

  const __arToPending = canPublish ? [_arToPending] : [];

  const __spamToPending = canPublish ? [_spamToPending] : [];

  const __spam = canPublish ? [_spam] : [];

  const options = React.useMemo(() => {
    if (status === EnumReviewType.Published) {
      if (isFake) {
        return [
          ...__publishAll,
          ...__unPublishAll,
          ...__edit,
          ...__archive,
          ...__deleteReview,
        ];
      } else {
        return [
          ...__publishAll,
          ...__unPublishAll,
          ...__spam,
          ...__archive,
          ...__deleteReview,
        ];
      }
    }
    if (status === EnumReviewType.Pending) {
      if (isFake) {
        return [...__publishAll, ...__edit, ...__archive, ...__deleteReview];
      } else {
        return [...__publishAll, ...__spam, ...__archive, ...__deleteReview];
      }
    }
    if (status === EnumReviewType.Spam) {
      return [...__spamToPending, ...__deleteReview];
    }
    if (status === EnumReviewType.Archive) {
      return [...__arToPending, ...__deleteReview];
    }
  }, [status, isFake, onEdit]);
  const { setReplyOpen, replyOpen, setCollapseOpen } = useContext(ReplyContext);
  const handleOnReplyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCollapseOpen(true);
    setReplyOpen(true);
  };
  return (
    <div className={css.wrapper}>
      <div className={css.frontContainer}>
        <div className={css.name}>
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        </div>
        <div className={css.rating}>
          <Rate hasText value={rating} disabled allowHalf />
        </div>
      </div>
      <div className={css.btnsContainer}>
        <Button
          className={css.reply}
          disabled={replyOpen || hasReply || !canReply}
          onClick={handleOnReplyClick}>
          {getI18n('reviews.productreview.reply')}
        </Button>
        <div className={css.dotsContainer}>
          <Dots options={options} iconClassName={css.iconDots} />
        </div>
      </div>
    </div>
  );
};
export default Title;
